import { observer } from 'mobx-react';
import FontBody3 from '../../../components/fonts/font-body3/font-body3';
import { FONT_COLOR } from '../../../components/fonts/font-props';
import useDashboardTranslation from '../../../dashboard-translation/hooks/dashboard-translation-hook';
import CustomerCaseStore from '../../manage-returns/rma-page/stores/customer-case-store';
import RmaShopperDetailsStore from '../../manage-returns/rma-page/stores/rma-shopper-details-store';
import CustomerDataCardAddressValue from './customer-data-card-address-value';
import CustomerDataCardShopperShippingSection from './customer-data-card-shopper-shipping-section';

interface IProps {
    orderShippingAddress?: string;
    customerCase?: CustomerCaseStore;
    addressId?: string | null;
    isGift?: boolean;
    shopperDetails?: RmaShopperDetailsStore;
}

const CustomerDataCardShippingSection: React.FC<IProps> = observer(({
    orderShippingAddress,
    customerCase,
    addressId,
    isGift,
    shopperDetails,
}) => {
    const pageScope = 'dashboard-create-rma';
    const { getTranslation } = useDashboardTranslation();
    const isGiftShippingNotRequired = addressId === null && isGift;

    if (shopperDetails) {
        return (
            <CustomerDataCardShopperShippingSection
                shopperDetails={shopperDetails}
                addressId={addressId}
                isGift={isGift}
            />
        );
    }

    return (
        <>
            <FontBody3 color={FONT_COLOR.PRIMARY2}>{getTranslation('SHIPPING_ADDRESS', pageScope)} </FontBody3>
            <CustomerDataCardAddressValue
                address={orderShippingAddress}
                isAddressRequired={!isGiftShippingNotRequired}
            />
            {customerCase?.updatedShippingAddress && (
                <>
                    <FontBody3 color={FONT_COLOR.PRIMARY2}>{getTranslation('UPDATED_ADDRESS', pageScope)}</FontBody3>
                    <CustomerDataCardAddressValue address={customerCase.updatedShippingAddress} />
                </>
            )}
        </>
    );
});

export default CustomerDataCardShippingSection;
